/* Legacy Layers – product page behaviour (pack picker, sticky ATC) */
  if (!customElements.get('ll-pack-picker')) {
    customElements.define('ll-pack-picker', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-pack-qty-input]');
        this.packs = this.querySelectorAll('.ll-pack');
        const active = this.querySelector('.ll-pack.is-active') || this.packs[0];
        if (active) this.input.value = active.dataset.qty || 1;
        this.packs.forEach((p) => p.addEventListener('click', () => {
          this.packs.forEach((o) => { o.classList.remove('is-active', 'is-activated'); o.setAttribute('aria-pressed', 'false'); });
          p.classList.add('is-active', 'is-activated'); p.setAttribute('aria-pressed', 'true');
          this.input.value = p.dataset.qty || 1;
        }));
      }
    });
  }
  if (!customElements.get('ll-sticky-atc')) {
    customElements.define('ll-sticky-atc', class extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.form);
        this.submit = document.getElementById('ProductSubmitButton-' + this.dataset.form.replace('product-form-', ''));
        if (!this.form || !this.submit || this.closest('quick-add-modal')) return;
        this.querySelector('[data-sticky-submit]').addEventListener('click', () => this.submit.click());
        const apply = (visible) => {
          this.hidden = visible || this.submit.disabled;
          document.body.classList.toggle('ll-sticky-atc-visible', !this.hidden);
        };
        const check = () => {
          const r = this.submit.getBoundingClientRect();
          apply(r.bottom > 0 && r.top < window.innerHeight);
        };
        if ('IntersectionObserver' in window) {
          new IntersectionObserver((entries) => apply(entries[0].isIntersecting), { threshold: 0 }).observe(this.submit);
        }
        // scroll fallback (throttled) for environments where IO is paused
        let ticking = false;
        window.addEventListener('scroll', () => { if (!ticking) { ticking = true; setTimeout(() => { ticking = false; check(); }, 120); } }, { passive: true });
        check();
        document.addEventListener('variant-change', () => this.syncPrice());
        new MutationObserver(() => { if (!this.hidden) this.querySelector('[data-sticky-submit]').disabled = this.submit.disabled; }).observe(this.submit, { attributes: true });
        this.syncPrice();
      }
      syncPrice() {
        const price = document.querySelector('#price-' + this.dataset.form.replace('product-form-', '') + ' .price-item--sale, #price-' + this.dataset.form.replace('product-form-', '') + ' .price-item--regular');
        const target = this.querySelector('.ll-sticky-atc__price');
        if (price && target) target.textContent = price.textContent.trim();
      }
    });
  }
  // Rating line -> smooth-scroll to the reviews widget lower on the page (no hash left in the URL)
  document.addEventListener('click', (e) => {
    const link = e.target.closest('.ll-rating-line--link[href^="#"]');
    if (!link) return;
    const target = document.querySelector(link.getAttribute('href'));
    if (!target) return;
    e.preventDefault();
    const sticky = document.querySelector('sticky-header');
    const alwaysSticky = sticky && ['always', 'reduce-logo-size'].includes(sticky.dataset.stickyType);
    const offset = (alwaysSticky ? sticky.offsetHeight : 0) + 16;
    const drift = () => target.getBoundingClientRect().top - offset;
    const atEnd = () => window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
    const go = () => window.scrollTo({ top: window.scrollY + drift(), behavior: 'smooth' });
    // Lazy-loaded images above the widget grow the page while we scroll, so after each scroll
    // finishes, scroll again until the widget actually sits under the header (max 4 passes).
    // Stop if the user takes over.
    let stop = false;
    ['wheel', 'touchstart', 'keydown'].forEach((ev) => window.addEventListener(ev, () => { stop = true; }, { once: true, passive: true }));
    const afterScroll = (cb) => {
      let done = false;
      const fire = () => { if (!done) { done = true; cb(); } };
      if ('onscrollend' in window) window.addEventListener('scrollend', fire, { once: true });
      setTimeout(fire, 'onscrollend' in window ? 1500 : 800);
    };
    const settle = (pass) => {
      if (stop || pass > 4 || Math.abs(drift()) < 3 || (atEnd() && drift() > 0)) return;
      go();
      afterScroll(() => settle(pass + 1));
    };
    settle(1);
  });
  // Desktop thumbnail layouts hide every gallery slide except the active one, so Dawn's
  // slider JS bails out (it needs two visible slides to work out a step) and the arrows we
  // overlay on the photo do nothing at all. Step the gallery directly in that case, and keep
  // the arrows' disabled state in step too, since Dawn's own update() never runs there either.
  const llArrowGallery = (sc) => (sc && sc.closest ? sc.closest('media-gallery') : null);
  const llArrowItems = (sc) => {
    const gallery = llArrowGallery(sc);
    return gallery ? Array.from(gallery.querySelectorAll('.product__media-item')) : [];
  };
  const llSyncArrows = (sc) => {
    const items = llArrowItems(sc);
    const i = items.findIndex((el) => el.classList.contains('is-active'));
    sc.querySelector('.slider-button--prev')?.toggleAttribute('disabled', i <= 0);
    sc.querySelector('.slider-button--next')?.toggleAttribute('disabled', i === -1 || i >= items.length - 1);
  };
  const llNativeSlider = (sc) => !sc.sliderItemsToShow || sc.sliderItemsToShow.length > 1;
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.ll-product slider-component:not(.thumbnail-slider) .slider-button');
    if (!btn) return;
    const sc = btn.closest('slider-component');
    if (llNativeSlider(sc)) return;
    const gallery = llArrowGallery(sc);
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;
    const items = llArrowItems(sc);
    const i = items.findIndex((el) => el.classList.contains('is-active'));
    const target = items[i + (btn.name === 'next' ? 1 : -1)];
    if (i === -1 || !target) return;
    gallery.setActiveMedia(target.dataset.mediaId, false);
    llSyncArrows(sc);
  });

  document.addEventListener('DOMContentLoaded', () => {
    document
      .querySelectorAll('.ll-product slider-component:not(.thumbnail-slider)')
      .forEach((sc) => { if (!llNativeSlider(sc)) llSyncArrows(sc); });
    // pubsub.js declares PUB_SUB_EVENTS with `const`, so it is a global binding but NOT a
    // window property; testing window.PUB_SUB_EVENTS was always false and nothing below ran.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => document.querySelectorAll('ll-sticky-atc').forEach((el) => el.syncPrice && el.syncPrice()));
      // Dawn moves the chosen colour's photo to the front of the gallery and then
      // smooth-scrolls to it. With scroll-snap on the list, Chrome re-snaps to the
      // slide that was already in view when the DOM re-orders, and the smooth scroll
      // can lose that race, leaving the old colour on screen. A follow-up instant
      // jump to the active slide (now slide 1) makes the swap deterministic.
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        setTimeout(() => {
          document.querySelectorAll('.product__media-list').forEach((list) => {
            const active = list.querySelector('.product__media-item.is-active');
            if (!active) return;
            const prev = list.style.scrollBehavior;
            list.style.scrollBehavior = 'auto';
            list.scrollTo({ left: active.offsetLeft, behavior: 'instant' });
            list.style.scrollBehavior = prev;
            // the "1/9" counter listens for scroll events; refresh it directly too
            const slider = list.closest('slider-component');
            if (slider && typeof slider.update === 'function') slider.update();
            if (slider && !llNativeSlider(slider)) llSyncArrows(slider);
          });
        }, 60);
      });
    }
  });
